import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import translations from '../utils/language/translations.json';
import '../utils/language/i18n';

const SeoHelmet = ({ type, data = {} }) => {
  const { i18n } = useTranslation();
   const currentLang = i18n.language;

const t = (key) => {
  const parts = key.split('.');
  let entry = translations.seo;

  for (const part of parts) {
    entry = entry?.[part];
    if (!entry) return '';
  }

  return entry?.[currentLang] || '';
};

  let title = '';
  let description = '';
  let image = '';
  const robots = 'index, follow';

  switch (type) {
    case 'homepage':
      title = t('home.title');
      description = t('home.description');
      image = 'https://cardsfolio.ca/og-home.jpg';
      break;

    case 'marketplace':
      title = t('marketplace.title');
      description = t('marketplace.description');
      image = 'https://cardsfolio.ca/og-marketplace.jpg';
      break;

    case 'trading':
      title = t('trading.title');
      description = t('trading.description');
      image = 'https://cardsfolio.ca/og-trading.jpg';
      break;

    case 'createCard':
      title = t('createCard.title');
      description = t('createCard.description');
      image = 'https://cardsfolio.ca/og-create.jpg';
      break;

    case 'profile':
      title = `${data?.username || t('profile.defaultTitle')} | CardsFolio`;
      description = t('profile.description')?.replace('{username}', data?.username || '');
      image = data?.profilePicture || '/default-avatar.png';
      break;

    case 'listing':
      title = `${data?.playerName || ''} ${data?.cardName || t('listing.defaultTitle')} | CardsFolio`;
      description = t('listing.description')
        ?.replace('{cardName}', data?.cardName || '')
        ?.replace('{playerName}', data?.playerName || '');
      image = data?.ImageFront || '/default-card-image.jpg';
      break;

    case 'faq':
      title = t('faq.title');
      description = t('faq.description');
      image = 'https://cardsfolio.ca/og-faq.jpg';
      break;

    case 'about':
      title = t('about.title');
      description = t('about.description');
      image = 'https://cardsfolio.ca/og-about.jpg';
      break;
   case 'messages':
      title = t('messages.title');
      description = t('messages.description');
      image = 'https://cardsfolio.ca/og-messages.jpg';
      break;

    case 'myCollection':
      title = t('myCollection.title');
      description = t('myCollection.description');
      image = 'https://cardsfolio.ca/og-collection.jpg';
      break;

         case 'search':
      title = t('search.title');
      description = t('search.description');
      image = 'https://cardsfolio.ca/og-search.jpg';
      break;
    case 'cart':
      title = t('cart.title');
      description = t('cart.description');
      image = 'https://cardsfolio.ca/og-cart.jpg';
      break;
    default:
      title = t('default.title') || 'CardsFolio';
      description = t('default.description') || 'Explore, trade, and manage your card collection.';
      image = '/default.jpg';
  }
console.log('[SeoHelmet]', {
  type,
  currentLang,
  resolvedTitle: title,
  resolvedDescription: description,
  t: t.toString(),
  rawTranslation: translations?.seo?.[type]?.[currentLang]
});

console.log('[SeoHelmet]', {
  type,
  currentLang,
  resolvedTitle: title,
  resolvedDescription: description,
  rawTitleKey: `${type}.title`,
  rawTitle: t(`${type}.title`),
  translationsEntry: translations?.seo?.[type]
});

// Debug log
console.log('[SeoHelmet]', {
  type,
  currentLang,
  resolvedTitle: title,
  resolvedDescription: description,
  rawTitleKey: `${type}.title`,
  rawTitle: t(`${type}.title`),
  translationsEntry: translations?.seo?.[type]
});
  return (
    <Helmet>
      <html lang={currentLang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta name="robots" content={robots} />
    </Helmet>
  );
};

export default SeoHelmet;
